import React, { useState, useEffect } from 'react';
import Header from './Header';

function UserDashboard() {
  const [selectedDepartment, setSelectedDepartment] = useState('');
  const [selectedForm, setSelectedForm] = useState('');
  const [availableForms, setAvailableForms] = useState([]);
  const [formData, setFormData] = useState({});
  const [currentForm, setCurrentForm] = useState(null);

  const currentUser = JSON.parse(localStorage.getItem('currentUser'));

  const departments = ['Department A', 'Department B', 'Department C'];

  // Load forms when department is selected
  useEffect(() => {
    if (selectedDepartment) {
      const allForms = JSON.parse(localStorage.getItem('forms') || '[]');
      const filtered = allForms.filter(form => form.department === selectedDepartment);
      setAvailableForms(filtered);
      setSelectedForm('');
      setCurrentForm(null);
      setFormData({});
    }
  }, [selectedDepartment]);

  // Load selected form
  useEffect(() => {
    if (selectedForm) {
      const allForms = JSON.parse(localStorage.getItem('forms') || '[]');
      const form = allForms.find(f => f.id === parseInt(selectedForm));
      setCurrentForm(form);
      setFormData({});
    }
  }, [selectedForm]);

  const handleInputChange = (fieldName, value) => {
    setFormData({
      ...formData,
      [fieldName]: value
    });
  };

  const handleSubmit = () => {
    // Get existing submissions
    const submissions = JSON.parse(localStorage.getItem('submissions') || '[]');
    
    const newSubmission = {
      id: Date.now(),
      formId: currentForm.id,
      formName: currentForm.name,
      department: currentForm.department,
      submittedBy: currentUser.name,
      submittedAt: new Date().toISOString(),
      data: formData
    };

    submissions.push(newSubmission);
    localStorage.setItem('submissions', JSON.stringify(submissions));

    alert('Form submitted successfully!');
    
    // Reset form
    setFormData({});
    setSelectedForm('');
    setCurrentForm(null);
  };

  return (
    <div className="min-h-screen bg-gray-50">
      
      <Header />

      <div className="p-6 max-w-4xl mx-auto">
        
        {/* Department and Form Selection */}
        <div className="bg-white rounded-lg shadow-sm p-6 mb-6">
          <h2 className="text-lg font-semibold text-gray-800 mb-4">Select Form</h2>
          
          <div className="space-y-4">
            
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">Department</label>
              <select
                value={selectedDepartment}
                onChange={(e) => setSelectedDepartment(e.target.value)}
                className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent outline-none"
              >
                <option value="">Select Department</option>
                {departments.map(dept => (
                  <option key={dept} value={dept}>{dept}</option>
                ))}
              </select>
            </div>

            {selectedDepartment && (
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Form</label>
                <select
                  value={selectedForm}
                  onChange={(e) => setSelectedForm(e.target.value)}
                  className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent outline-none"
                >
                  <option value="">Select Form</option>
                  {availableForms.map(form => (
                    <option key={form.id} value={form.id}>{form.name}</option>
                  ))}
                </select>
              </div>
            )}

          </div>
        </div>

        {/* Form Display */}
        {currentForm && (
          <div className="bg-white rounded-lg shadow-sm p-6">
            
            <h2 className="text-xl font-semibold text-gray-800 mb-6">{currentForm.name}</h2>

            <div className="space-y-5">
              
              {currentForm.fields.map((field) => (
                <div key={field.id}>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    {field.name}
                  </label>

                  {/* Text Input */}
                  {field.fieldType === 'Text Input' && (
                    <input
                      type="text"
                      value={formData[field.name] || ''}
                      onChange={(e) => handleInputChange(field.name, e.target.value)}
                      className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent outline-none"
                    />
                  )}

                  {/* Radio Button */}
                  {field.fieldType === 'Radio Button' && (
                    <div className="flex gap-4">
                      <label className="flex items-center gap-2">
                        <input
                          type="radio"
                          name={field.name}
                          value="Male"
                          checked={formData[field.name] === 'Male'}
                          onChange={(e) => handleInputChange(field.name, e.target.value)}
                          className="w-4 h-4"
                        />
                        <span>Male</span>
                      </label>
                      <label className="flex items-center gap-2">
                        <input
                          type="radio"
                          name={field.name}
                          value="Female"
                          checked={formData[field.name] === 'Female'}
                          onChange={(e) => handleInputChange(field.name, e.target.value)}
                          className="w-4 h-4"
                        />
                        <span>Female</span>
                      </label>
                    </div>
                  )}

                  {/* Dropdown List */}
                  {field.fieldType === 'Dropdown List' && (
                    <select
                      value={formData[field.name] || ''}
                      onChange={(e) => handleInputChange(field.name, e.target.value)}
                      className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent outline-none"
                    >
                      <option value="">Select...</option>
                      <option value="Option 1">Option 1</option>
                      <option value="Option 2">Option 2</option>
                      <option value="Option 3">Option 3</option>
                    </select>
                  )}

                  {/* File */}
                  {field.fieldType === 'File' && (
                    <input
                      type="file"
                      onChange={(e) => handleInputChange(field.name, e.target.files[0]?.name || '')}
                      className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent outline-none"
                    />
                  )}

                  {/* Textarea */}
                  {field.fieldType === 'Textarea (Paragraph)' && (
                    <textarea
                      value={formData[field.name] || ''}
                      onChange={(e) => handleInputChange(field.name, e.target.value)}
                      rows="4"
                      className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent outline-none"
                    />
                  )}

                  {/* Checkbox */}
                  {field.fieldType === 'Checkbox' && (
                    <label className="flex items-center gap-2">
                      <input
                        type="checkbox"
                        checked={formData[field.name] || false}
                        onChange={(e) => handleInputChange(field.name, e.target.checked)}
                        className="w-4 h-4"
                      />
                      <span>I agree</span>
                    </label>
                  )}

                </div>
              ))}

            </div>

            <button
              onClick={handleSubmit}
              className="w-full mt-6 px-4 py-3 bg-green-600 text-white rounded-md font-medium hover:bg-green-700 transition"
            >
              Submit
            </button>

          </div>
        )}

        {/* No form selected message */}
        {!currentForm && selectedDepartment && availableForms.length === 0 && (
          <div className="bg-white rounded-lg shadow-sm p-12 text-center">
            <p className="text-gray-500">No forms available for this department.</p>
          </div>
        )}

      </div>

    </div>
  );
}

export default UserDashboard;